export default "<svg viewBox=\"0 0 27 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2 2h22M2 10h22M2 18h22\"/></svg>";